import { noop } from '@braskai/ui-kit';

import UserPromptingPlaceholder from '@/shared/assets/images/user-prompting-feature.png';
import UserPromptingTrialPlaceholder from '@/shared/assets/images/user-prompting-trial.png';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock Translation prompting feature',
  bulletsHeader: BULLETS_HEADER_TEXT.inTrial,
  buttonText: BUTTON_TEXTS.choosePlan,
  features: getBullets([
    'userPrompting',
    'translate2000',
    'teamspace',
    'voicePresetsUnlimited',
    'glossary',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
    'simultaneousMultiLanguageTranslation',
    'api',
    'noWatermark',
    'customPriceForMins',
    'humanInTheLoop',
    'businessContract',
    'personalManager',
  ]),
  media: {
    src: UserPromptingPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: noop,
  mixpanelOpeningEvent: noop,
  subtitle:
    'Set the tone, style, and context for translations with prompts. Pick from our templates or write your own prompt to fit your needs.',
};

const TRIAL_PLAN_CONTENT = {
  ...BASE_CONTENT,
  title: 'Unlock Translation prompting',
  buttonText: 'Choose plan',
  content: {
    chip: {
      title: 'Enterprise users confirm translation edits up to 5× faster',
    },
    learnMore: {
      title: 'Learn more',
      link: 'https://help.rask.ai/hc/introducing-prompting',
      text: 'how to use prompting effectively',
    },
    perfectFor: {
      title: 'Perfect for',
      text: 'brands and creators who need on-brand translations without heavy editing.',
    },
    whatYouCanDo: {
      title: 'Control your translation',
      bullets: [
        'Set tone and formality level',
        'Guide word choice and terminology',
        'Use ready-made templates or write custom prompts',
      ],
    },
  },
  features: [],
  media: {
    ...BASE_CONTENT.media,
    src: UserPromptingTrialPlaceholder,
  },
  subtitle: 'Make your dubbed videos match your brand voice.',
};

const CREATOR_PRO_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inCreatorPro,
  buttonText: BUTTON_TEXTS.toBusiness,
  features: getBullets([
    'userPrompting',
    'translate2000',
    'teamspace',
    'voicePresetsUnlimited',
    'glossary',
    'simultaneousMultiLanguageTranslation',
    'api',
  ]),
  subtitle: 'Upgrade to Business to have Team space with up to 10 members',
};

const BUSINESS_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inBusiness,
  buttonText: BUTTON_TEXTS.contactUs,
  features: getBullets([
    'userPrompting',
    'translate2000',
    'voicePresetsUnlimited',
    'customPriceForMins',
    'humanInTheLoop',
    'businessContract',
    'personalManager',
  ]),
  subtitle: 'Upgrade to Enterprise to have unlimited Team spaces and members',
};

export const USER_PROMPTING_CONTENT: LimitedFeatureContent = {
  business: BUSINESS_PLAN_CONTENT,
  creator: BASE_CONTENT,
  creatorPro: CREATOR_PRO_PLAN_CONTENT,
  enterprise: BUSINESS_PLAN_CONTENT,
  starter: BASE_CONTENT,
  trial: TRIAL_PLAN_CONTENT,
};
